import { useParams } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import TopBar from "./TopBar";
import { useEffect, useState } from "react";
import ProductService from "../../Services/ProductService";
import _ from "lodash";
import ProductsList from "../Product/ProductsList";
import ProductsLoader from "../Product/ProductsLoader";
import EmptyError from "../EmptyError/EmptyError";

const ProductsListPage = () => {
  const { skus } = useParams();
  const [products, setProducts] = useState(null);
  const [loading, setLoading] = useState("not_started");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (skus) {
      setLoading("started");
      const { axiosRequest, abortController } =
        ProductService.getProductsListBySKUs(skus);
      axiosRequest
        .then((response) => {
          if (response?.data?.responseData?.productGists?.length > 0) {
            let productsFromResponse = response.data.responseData.productGists;
            productsFromResponse = _.filter(productsFromResponse, (product) => {
              return (
                product.brandName !== "Unassigned Brand" &&
                ProductService.checkIfProductEnabled(product)
              );
            });
            setProducts(productsFromResponse);
          } else {
            console.log(`no response received in responseData`);
            setProducts([]);
          }
          setLoading("done");
        })
        .catch((error) => {
          if (error?.message !== "canceled") {
            console.log(`error getting products`);
            if (error?.data) {
              console.log(error.data);
              setError(error.data);
            } else {
              console.log(error);
              setError(error);
            }
          }
          setLoading("done");
        });
      return () => abortController.abort();
    } else {
      console.log(`no SKUs found in route`);
      setLoading("done");
    }
  }, [skus]);

  return (
    <>
      <ErrorBoundary message={``}>
        <TopBar
          title={`Products`}
          backNavigation={true}
          backLink={"/vyapaar"}
          showCart={true}
          showHisaab={true}
        />
        {loading !== "started" && !error && products && products?.length > 0 ? (
          <>
            <ProductsList
              loading={loading}
              products={products}
              page={`Products Page`}
            />
          </>
        ) : loading === "done" && !error && products?.length === 0 ? (
          <EmptyError
            image="EmptyPage.svg"
            text=""
            subText="Sorry! No products here."
          />
        ) : (
          <ProductsLoader />
        )}
        {error && (
          <EmptyError
            image="EmptyPage.svg"
            text=""
            subText="Something went wrong, Please try later."
          />
        )}
      </ErrorBoundary>
    </>
  );
};

export default ProductsListPage;
